import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';

export const icoSellCarRoutes = [
  {
    path: `/sell-car/instant-cash-offer`,
    exact: true,
    page: getLoadablePage(
      () => import(/* webpackChunkName: "ico_standalone_offer_page" */ '../pages/standalone-ico-offer')
    ),
    chunkName: 'ico_standalone_offer_page',
    enableLooseEtag: true,
  },
];
